export enum DeploymentEnvironment {
    PRODUCTION = 'PRODUCTION', SANDBOX = 'SANDBOX'
}
